<template>
  <span :class="$style.wave">
    <span v-for="index in 4" :key="index" :class="$style.wave__item" />
  </span>
</template>

<style lang="scss" module>
$color: $color-text-and-object-accent-primary;

@keyframes wave-surge {
  from {
    // background-color: color.change($color, $alpha: 0.21);
    background-color: rgba($color, 0.21);
    transform: translateY(0%);
  }

  16% {
    // background-color: color.change($color, $alpha: 0.33);
    background-color: rgba($color, 0.33);
    transform: translateY(50%);
  }

  43% {
    // background-color: color.change($color, $alpha: 1);
    background-color: rgba($color, 1);
    transform: translateY(-50%);
  }

  66% {
    // background-color: color.change($color, $alpha: 0.7);
    background-color: rgba($color, 0.7);
    transform: translateY(0%);
  }
}

.wave {
  $size: 8px;
  $gap: math.div($size * 3, 4);
  $number: 4;

  display: inline-flex;
  width: ($size * $number) + ($gap * ($number - 1));
  align-items: center;

  &__item {
    width: $size;
    height: $size;
    background-color: color.adjust(
      $color: $color,
      $hue: -100deg,
      $lightness: 30%,
      $saturation: -40%
    );
    border-radius: 50%;

    &:nth-child(n + 2) {
      margin-left: $gap;
    }

    @for $i from 1 through $number {
      $duration: 2.4s;
      $delay: $i * 300ms;

      &:nth-child(#{$i}) {
        animation: wave-surge $duration ease-out $delay infinite normal;
      }
    }
  }
}
</style>
